var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Validation from "@irati/utils/validation";
import Button from "../Button/Button";
var ValidationButton = /** @class */ (function (_super) {
    __extends(ValidationButton, _super);
    function ValidationButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var onClick = _this.props.onClick;
            return Validation.validate(_this.context.currentScreen)
                .then(function () {
                onClick(e);
            })
                .catch(function () { });
        };
        return _this;
    }
    ValidationButton.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, props = __rest(_a, ["onClick"]);
        return React.createElement(Button, __assign({}, props, { onClick: this.handleClick }));
    };
    ValidationButton.contextTypes = {
        currentScreen: PropTypes.string
    };
    ValidationButton.defaultProps = {
        onClick: function () { }
    };
    return ValidationButton;
}(PureComponent));
export default styled(ValidationButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
